export enum OrderTypeValues {
  GravyOrder = 'gravy:order',
  GiftCardOrder = 'giftcard:order',
}
